import apiClient from './client';

export const ActivityBundleAxiosInstance = apiClient;